import React, { memo } from 'react';
import classNames from 'classnames';

import IconX from '@zvuk-b2b/react-uikit/ui/icons/X';

import type { AppliedTagsProps } from '../types';

import styles from '../index.module.scss';

const AppliedTags: React.FC<AppliedTagsProps> = ({
  hiddenSelectedTagsCount,
  isExpanded,
  isToggleVisible,
  tags,
  texts,
  testIds,
  onClear,
  onRemove,
  onToggle,
}) => {
  const toggleButtonText = isExpanded ? texts.hideTags : texts.moreTags(hiddenSelectedTagsCount);
  const toggleButtonLabel = isExpanded ? texts.hideTags : texts.showAllTags;

  return (
    <div
      className={styles.appliedTags}
      data-testid={testIds.appliedTags}>
      {tags.map((tag) => (
        <button
          key={tag.id}
          type="button"
          className={styles.appliedTag}
          aria-label={texts.removeTag(tag.title)}
          data-testid={testIds.appliedTagRemove(tag.id)}
          onClick={() => onRemove(tag.id)}>
          <IconX className={styles.appliedTagIcon} />
          <span
            className={styles.appliedTagTitle}
            data-testid={testIds.appliedTag(tag.id)}>
            {tag.title}
          </span>
        </button>
      ))}

      {isToggleVisible && (
        <button
          type="button"
          className={classNames(styles.appliedTag, styles.appliedTagsToggle)}
          aria-label={toggleButtonLabel}
          data-testid={testIds.appliedTagsMore}
          onClick={onToggle}>
          {toggleButtonText}
        </button>
      )}

      <button
        type="button"
        className={styles.clearTagsButton}
        data-testid={testIds.appliedTagsClear}
        onClick={onClear}>
        {texts.clearTags}
      </button>
    </div>
  );
};

export default memo(AppliedTags);
